var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61454 16.9908C1.19697 17.0153 0.786298 16.8751 0.469133 16.5998C-0.156378 15.9645 -0.156378 14.9383 0.469133 14.3029L14.1658 0.472773C14.8164 -0.141936 15.8372 -0.107765 16.446 0.549162C16.9965 1.14322 17.0286 2.0563 16.5211 2.68822L2.7438 16.5998C2.43072 16.8712 2.02664 17.0111 1.61454 16.9908Z",
    fill: "#8D8D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2632 16.9912C14.84 16.9894 14.4344 16.8198 14.1339 16.5188L0.437235 2.68859C-0.142268 2.00527 -0.0634818 0.976914 0.613243 0.39171C1.21724 -0.13057 2.10801 -0.13057 2.71195 0.39171L16.4893 14.2219C17.1397 14.8367 17.1733 15.8676 16.5644 16.5244C16.5402 16.5505 16.5152 16.5758 16.4893 16.6002C16.1519 16.8965 15.708 17.038 15.2632 16.9912Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGray);
export default __webpack_public_path__ + "static/media/close-gray.37f1d6e50fdfc2f624b235d4e1a22579.svg";
export { ForwardRef as ReactComponent };